
import ArrowDown from "../../../assets/duotone/ArrowDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowDownIcon({ className, dataTestid = "ArrowDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
